import NewWedingModal from './NewWedingModal'
import styles from './NewWedingModal.module.scss'
import ButtonCustom from '../../../components/atoms/button/ButtonCustom'
import Stepper from '../../../components/atoms/Stepper/Stepper'
import { useDispatch } from 'react-redux'
import { createKazoo, createKazooAsPlanner } from '../../../features/kazooEventSlice'
import { toastHelper } from '../../../util/toastHelper'

const shareMethods = [
	'Digital (Budget Friendly Option)',
	'Printed (Traditional)',
	'Decide later',
]

function ShareInvitations({
	open,
	handleClose,
	handleNext,
	handleBack,
	weddingData,
	setWeddingData,
}) {
	const dispatch = useDispatch()

	const handleFinish = () => {
		if (!weddingData.invitationShareMethod)
			return toastHelper('Please select an option', 'error')
        if(weddingData.role === 'Wedding Planner'){
            dispatch(createKazooAsPlanner(weddingData))
        } else {
            dispatch(createKazoo(weddingData))
        }
		handleNext()
	}

	return (
		<NewWedingModal
			open={open}
			handleClose={handleClose}
			handleBack={() => handleBack()}
			modalImage="/images/GuestCount.jpg"
		>
			<div
				className={`${styles.welcomeModal} ${styles.guestCount} ${styles.modalMainContainer}`}
			>
				<div className={styles.welcomeModalBody}>
					<h2>How do you want to share invitations?</h2>
					<div
						className=""
						style={{ width: '100%', marginTop: '40px' }}
					>
						<div className={styles.modalContainer}>
							<div className={styles.Budget}>
								{shareMethods.map((label, idx) => (
									<ButtonCustom
                                        key={idx}
										data-cy={`${label}`}
										variant="pilled"
										style={{
											backgroundColor:
												weddingData?.invitationShareMethod ===
												label
													? '#7ca6bd'
													: '#FFF',
											color:
												weddingData?.invitationShareMethod ===
												label
													? '#FFF'
													: '#7ca6bd',
										}}
										onClick={() =>
											setWeddingData({
												...weddingData,
												invitationShareMethod: label,
											})
										}
									>
										{label}
									</ButtonCustom>
								))}
							</div>
						</div>
					</div>
				</div>
				<ButtonCustom size="lg" data-cy="wizard-finish" onClick={handleFinish}>
					Finish
				</ButtonCustom>
				<div className={styles.buttonContainer}>
					<Stepper activeStep={3} />
				</div>
			</div>
		</NewWedingModal>
	)
}

export default ShareInvitations
